module.exports = __webpack_public_path__ + "img/43480fb1bea7ad80d2aef90b05f59015.svg";